import {addUcCommonParam, getCpParams, getFrontEndInfo, getPageBizParam} from './ucparam';
import * as queryString from 'querystring';
import {LT_WA_AIR, WA_AIR_APPID} from '../../const/code';
import * as compareVersions from 'compare-versions';
import {Browser} from '../../const/env';

interface ICommonWaStatData {
  app: string;
  lang: string;
  set_lang: string;
  ct_lang: string;
  ver: string;
  sver: string;
  brow_ver: string;
  brow_sver: string;
  entry: string;
  entry1: string;
  entry2: string;
  pos: string;
  ut: string;
  referrer: string;
  project: string;
  position: string;
  siteKey: string;
}

const COMMON_FIELDS = ['app', 'lang', 'set_lang', 'ct_lang',
  'ver', 'sver', 'brow_ver', 'brow_sver',
  'entry', 'entry1', 'entry2',
  'pos', 'ut', 'referrer', 'project', 'position'];

function sendWaStatFinal(params) {
  const url = 'https://gjtrack.ucweb.com/collect';
  const completeURL = url + '?' + queryString.stringify(params);
  const env = window._ENVI_INFO;
  if (navigator.sendBeacon && ((env.isUcBrowser && env.ver && compareVersions(env.ver, '12.0.0') >= 0) || env.browser === Browser.not_uc_client)) {
    // console.log('BEQACON');
    navigator.sendBeacon(completeURL, '');
  } else {
    (new Image()).src = completeURL;
  }
}

export function sendWaStat(lt: string, ct: string, ev_ct: string, params) {
  const ENVI_INFO = (window as any)._ENVI_INFO;
  const statInfo = (window as any)._STAT_STORY;

  // 补充公参
  params = addUcCommonParam(params);

  // 补充通用统计参数
  params = Object.assign({}, getFrontEndInfo(), getPageBizParam(), statInfo, params, {
    appid: WA_AIR_APPID,
    lt, ct, ev_ct,
  });
  if (ENVI_INFO.page && !params.page) {
    params.page = ENVI_INFO.page;
  }

  // appID: '20131', // wa的appId
  //   appCode: 'globalnews', // wa的appCode
  //   jslogId: '4ea393c92d74', // appIdJsLog

  sendWaStatFinal(params);

}

export function sendWaStatWithoutStatInfo(lt: string, ct: string, ev_ct: string, params) {
  const ENVI_INFO = (window as any)._ENVI_INFO;
  // 补充公参
  params = addUcCommonParam({...params, ...getCpParams()});
  params = Object.assign({}, getFrontEndInfo(), getPageBizParam(), params, {
    appid: WA_AIR_APPID,
    lt, ct, ev_ct,

    client: ENVI_INFO.client,
    siteKey: ENVI_INFO.siteKey,
    page: ENVI_INFO.page,

  });

  sendWaStatFinal(params);
}

export function getHostAndPort() {
  let hostAndPort;
  hostAndPort = location.hostname + (location.port ? ':' + location.port : '');
  return hostAndPort;
}

export function pv() {
  const params = {
    domain: getHostAndPort(),
  };

  sendWaStat(LT_WA_AIR, 'jslog', 'pv', params);
}

export function pvWithParams(params) {
  const paramsObj = Object.assign({}, params, {
    domain: getHostAndPort(),
  });
  sendWaStat(LT_WA_AIR, 'jslog', 'pv', paramsObj);
}

interface IAction {
  ac_name?: string; // appear, click,
  ac_type?: string; // ad
  pos?;
  like_count?;
  jumpurl?; // 跳转链接
  ev_ac?; // action
  rt?; // 用时
  page_num?; // 相关推荐 第n页
  domain?;
  is_insert?;
  article_id?;
  cost_time?;
}

interface IAdAction extends IAction {
  adpf: string; // js, sdk
  adslot: string; // 广告位置,业务编号，1-正文页，2-信息流，3-article topbanner，4-Atlas，5-其他
  adid: string; // 广告调用id
  adtype?: string; // 广告类型打点
  userHash?: number; // 灰度使用的hash值
  bucketHash?: number; // 分桶使用的hash
  chance?: number; // 灰度的值
  bucket?: number; // 桶的数量
  isUserTakeChance?: boolean; // 是否灰度用户
  userDistributeToBuckets?: number; // 目标桶,0表示A，1表示B 以此类推
  adwork: string; // 广告网络
  costTime?: number;
}

interface IWaMust {
  lt: string;
  ct: string;
  ev_ct: string;
}

export function waAction(params: IAdAction | IAction) {
  sendWaStat(LT_WA_AIR, 'jslog', 'action', params);
}

export function waLogRaw(lt: string, ct: string | null, ev_ct: string, params: IAction) {
  sendWaStatWithoutStatInfo(lt, ct || 'jslog', ev_ct, params);
}

export function image(params) {
  sendWaStatWithoutStatInfo(LT_WA_AIR, 'jslog', 'image', params);
}

export function introduce(params) {
  sendWaStatWithoutStatInfo(LT_WA_AIR, 'jslog', 'introduce', params);
}

export function waPerformance(params) {
  sendWaStatWithoutStatInfo(LT_WA_AIR, 'jslog', 'performance', params);
}

export function waPerformance2(params) {
  sendWaStatWithoutStatInfo(LT_WA_AIR, 'jslog', 'performance2', params);
}

export function waStep(params) {
  sendWaStatWithoutStatInfo(LT_WA_AIR, 'jslog', 'page_steps', params);
}
